import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Header from 'components/Header/Header';
import NavigationBar from 'components/NavigationBar/NavigationBar';
import PreLoginNavigationBar from 'components/NavigationBar/PreLoginNavigationBar';
import Footer from 'components/Footer/Footer';
import { GetprofileDriverStylingApi } from 'store/profile/action';
import { setCustomerName } from 'store/home/action';

export default function Layout(props) {
  const { isPrelogin } = props;
  const dispatch = useDispatch();
  const userParams = useParams();
  const styling = useSelector((state) => state.profileState.profileDriverSetStyling);

  useEffect(() => {
    dispatch(GetprofileDriverStylingApi(userParams.customer));
  }, [userParams.customer]);

  useEffect(() => {
    if (userParams?.customer) {
      dispatch(setCustomerName(userParams.customer));
    }
  }, [dispatch, userParams?.customer]);

  return (
    <>
      <a href="#main-content" className="skip-nav">Skip to main content</a>
      <Header styling={styling} />
      <nav aria-label="Main navigation">
        { isPrelogin ? (
          <PreLoginNavigationBar StylingItem={styling} isPrelogin={isPrelogin} />
        ) : (
          <NavigationBar StylingItem={styling} />
        )}
      </nav>
      <main id="main-content">
        { React.cloneElement(props.children, { StylingItem: styling }) }
      </main>
      <Footer StylingItem={styling} />
    </>
  );
};

Layout.defaultProps = {
  isPrelogin: false,
};
